export const getFormattedIsoDateValueCol = (value: string | null): string | null => {
  try {
    return value ? new Date(value).toISOString() : null
  } catch {
    return null
  }
}
